<template>
  <el-dialog
    v-model="visible"
    title=""
    width="400px"
    @close="(val) => changeResultClose(false)"
  >
    <template #header>
      <div class="header-text">提醒：您将通过文件审核</div>
    </template>
    <div>
      <el-form ref="form" :model="formInfo" label-width="none">
        <el-form-item
          label=""
          prop="comment"
          :rules="{
            required: true,
            message: '请输入原因',
          }"
        >
          <el-input
            v-model="formInfo.comment"
            style="width: 90%"
            :autosize="{ minRows: 2, maxRows: 6 }"
            type="textarea"
            placeholder="请输入原因"
          />
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="changeResultClose(false)">取消</el-button>
        <el-button type="primary" @click="submit"> 确认 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
import { changeFileAuditResult } from "@/api/index";
import { toRefs, ref } from "vue";
import { ElMessage } from "element-plus";

const props = defineProps<{ visible: Boolean; rowData: Object }>();
const { visible, rowData } = toRefs(props);
const emit = defineEmits(["close"]);
const changeResultClose = (searchable) => {
  emit("close", searchable);
};
const form = ref(null);
const submit = async () => {
  const valid = await form.value?.validate()?.catch(() => false);
  if (!valid) return;
  // 掉接口
  const res = await changeFileAuditResult({
    filename: rowData.value.hash_value,
    id: rowData.value.id,
    review_result: true,
    reason: formInfo.value.comment,
  });

  if (res.code === "success") {
    changeResultClose(true);
    ElMessage({
      message: res.message,
      type: "success",
    });
  }
};
const formInfo = ref({
  comment: "",
});
</script>

<style lang="scss" scoped>
.header-text {
  font-size: 16px;
  font-weight: 600;
}
</style>
